import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Pickaxe, Home, PlayCircle, Video, Mail } from "lucide-react";

export default function Tutorials() {
  const [vids, setVids] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    fetch("/tutorials/manifest.json")
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => {
        setVids(data);
        if (data.length) setActive(data[0]);
      })
      .catch(() => setVids([]));
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="tutorials-brand">
            <img src="/assmang-logo.png" alt="Assmang logo" className="h-9 w-auto" />
            <span className="hidden sm:inline font-display font-extrabold text-slate-900 tracking-tight">ASSMANG SMME PORTAL</span>
          </Link>
          <div className="flex items-center gap-2">
            <Link to="/user-manual" className="text-sm font-semibold text-slate-600 hover:text-[#00427A] border border-slate-200 hover:border-[#00427A] rounded-md px-3 py-1.5 transition-colors">User Manual</Link>
            <Link to="/" data-testid="tutorials-home-button" className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 hover:text-[#00427A] border border-slate-200 hover:border-[#00427A] rounded-md px-3 py-1.5 transition-colors">
              <Home className="h-4 w-4" /> Home
            </Link>
          </div>
        </div>
      </header>

      <section className="relative overflow-hidden bg-[#1E252B]">
        <div className="relative z-10 max-w-5xl mx-auto px-5 sm:px-8 py-14">
          <p className="font-mono-data text-xs uppercase tracking-[0.25em] text-[#FCD34D] font-semibold mb-4 flex items-center gap-2">
            <Video className="h-4 w-4" /> Video Tutorials
          </p>
          <h1 className="font-display text-4xl sm:text-5xl font-black text-white tracking-tight">Learn the portal in minutes</h1>
          <p className="text-slate-300 mt-4 max-w-2xl">Narrated step-by-step walkthroughs for SMME suppliers and mine buyers.</p>
        </div>
      </section>

      <main className="max-w-5xl mx-auto px-5 sm:px-8 py-12">
        {vids.length === 0 ? (
          <div className="text-center py-20 bg-white rounded-xl border border-slate-200">
            <Video className="h-10 w-10 text-slate-300 mx-auto mb-3" />
            <p className="font-semibold text-slate-700">Tutorials are being prepared</p>
            <p className="text-sm text-slate-500 mt-1">Please check back shortly.</p>
          </div>
        ) : (
          <div className="grid lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2">
              {active && (
                <div className="bg-black rounded-xl overflow-hidden border border-slate-200">
                  <video key={active.file} data-testid="tutorial-player" src={active.file} controls autoPlay
                    className="w-full aspect-video bg-black" />
                </div>
              )}
              {active && <h2 className="font-display text-xl font-bold text-slate-900 mt-4">{active.title}</h2>}
            </div>
            <div className="space-y-3">
              <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">All tutorials</p>
              {vids.map((v) => (
                <button key={v.id} data-testid={`tutorial-item-${v.id}`} onClick={() => setActive(v)}
                  className={`w-full flex items-center gap-3 text-left rounded-lg border px-4 py-3 transition-colors ${active?.id === v.id ? "border-[#00427A] bg-[#00427A]/5" : "border-slate-200 bg-white hover:border-slate-300"}`}>
                  <PlayCircle className={`h-5 w-5 shrink-0 ${active?.id === v.id ? "text-[#00427A]" : "text-slate-400"}`} />
                  <span className="text-sm font-semibold text-slate-800">{v.title}</span>
                </button>
              ))}
              <a href="mailto:support@assmangsmmeportal.com"
                className="flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-[#00427A] hover:border-[#00427A] transition-colors">
                <Mail className="h-4 w-4" /> support@assmangsmmeportal.com
              </a>
            </div>
          </div>
        )}
      </main>

      <footer className="bg-[#1E252B] text-slate-400 py-8">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 flex items-center gap-2">
          <Pickaxe className="h-5 w-5 text-[#F2B50C]" />
          <span className="font-display font-bold text-white">ASSMANG SMME PORTAL</span>
        </div>
      </footer>
    </div>
  );
}
